/**
 * Point d'ancrage découplé entre `apiFetch` (bas niveau, ne connaît pas le
 * routeur) et la navigation (`router.tsx`, qui, lui, importe `apiFetch`
 * indirectement via les hooks de requête). `main.tsx` enregistre le
 * gestionnaire une fois au démarrage.
 */
type UnauthorizedHandler = () => void;

let handler: UnauthorizedHandler | null = null;

export function setUnauthorizedHandler(next: UnauthorizedHandler): void {
  handler = next;
}

export function notifyUnauthorized(): void {
  handler?.();
}
